import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import trackingServices from "../../../Services/trackingService";

export function TrackingDetails() {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [trackData, setTrackData] = useState({});
  const [jobStatus, setJobStatus] = useState("");
  const history = useHistory();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const jobId = params.get("id");

  useEffect(() => {
    let data = { job_token: jobId };
    trackingServices.getTrackingDetail(data).then((result) => {
      if (result.status === true) {
        setTrackData(result.data);
        setIsDataLoaded(true);
      }
    });
    setJobStatus(trackData.job_status);
  }, []);

  const convertToDate = (data) => {
    if(data){
      return new Date(data).toLocaleString();
    } else {
      return false
    }
  };
  
  return (
    isDataLoaded && (
      <div className="container-fluid">
        <div className="white_box h-100">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="row">
                <div className="col-md-12 my-4">
                  <h3 className="mb-3 d-flex align-items-center">
                    <b>Tracking Id - {trackData.quote_token} </b>
                    <img
                      className="shareicon"
                      src="/admin/assets/images/share_icon.svg"
                      height="20"
                    />
                  </h3>
                </div>

                <div className="col-md-12 d-flex align-items-center">
                  <div id="trackingSec" className="trackingSec mx-auto">
                    <div className="overflow-auto">
                      {Array.isArray(trackData.job_status_values) &&
                        trackData.job_status_values.map((item, key) => {
                          return (
                            <div
                              className={item.change_date !== 0 ? "active" : ""}
                            >
                              <div className={`trackingText-${key + 1}`}>
                                {item.text}
                              </div>
                              <span className="checkicon"></span>
                              <span>{item.job_status.replace(/_/g, " ")} </span>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="card p-3">
                    <div className="row">
                      <div className="col-lg-4 col-md-6 ">
                        <h5 className="secHeading">Tracking Details</h5>
                        <table width="100%">
                          <tbody>
                            <tr>
                              <td className="py-1"> Job No. - </td>
                              <td className="py-1">{trackData.job_token}</td>
                            </tr>
                            <tr>
                              <td className="py-1">Customer Name - </td>
                              <td className="py-1">
                                {trackData.user_full_name}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1">Mawb / M BL - </td>
                              <td className="py-1">
                                {trackData.carrier_details.m_awb_m_b_l}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1">Hawb / H BL - </td>
                              <td className="py-1">
                                {trackData.carrier_details.m_awb_h_b_l}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1">
                                Current Shipment Status -
                              </td>
                              <td>
                                <span className="badge rounded-pill font-size-12 pointer bg-warning">
                                  {trackData.current_shipment_status.replaceAll(
                                    "_",
                                    " "
                                  )}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1">Update Shipment Status -</td>
                              <td>
                                <span className="badge rounded-pill font-size-12 pointer bg-success">
                                  {trackData.job_status.replaceAll("_", " ")}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td className="py-1">Expected Delivery Date -</td>
                              <td className="py-1">
                                {convertToDate(trackData.expacted_date)}
                              </td>
                            </tr>

                            <tr>
                              <td colSpan={2}>
                                <b>Tracking Status:</b>
                              </td>
                            </tr>

                            {trackData.job_status_values.map((item) => {
                              return (
                                <tr>
                                  <td className="py-1">{item.job_status}</td>
                                  <td className="py-1">{item.tracking_date}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="col-lg-8 col-md-6 border-start">
                        <h5 className="secHeading">Add Ons Comments</h5>
                        <div>
                          <p> {trackData.add_ons_comment} </p>
                        </div>

                        <h5 className="secHeading">Cargo Comments</h5>
                        <div>
                          <p> {trackData.cargo_details_comment} </p>
                        </div>

                        <h5 className="secHeading">Carrier Comments</h5>
                        <div>
                          <p> {trackData.carrier_details_comment} </p>
                        </div>

                        <h5 className="secHeading">Cost Comments</h5>
                        <div>
                          <p> {trackData.cost_comment} </p>
                        </div>

                        <h5 className="secHeading">Receiver Comments</h5>
                        <div>
                          <p> {trackData.receiver_details_comment} </p>
                        </div>

                        <h5 className="secHeading">Revenue Comments</h5>
                        <div>
                          <p> {trackData.revenue_comment} </p>
                        </div>

                        <h5 className="secHeading">Schedule Pickup Comments</h5>
                        <div>
                          <p> {trackData.schedule_pickup_comment} </p>
                        </div>

                        <h5 className="secHeading">Sender Details Comments</h5>
                        <div>
                          <p> {trackData.sender_details_comment} </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
